module.exports = __webpack_public_path__ + "img/apoio_bco_mundial.c581421a.png";